import type { ReactNode } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@localagent/ui/components/tabs';

export const PAGE_TABS_LIST_CLASS = 'h-12 gap-1 rounded-none bg-transparent p-0';

export const PAGE_TABS_TRIGGER_CLASS = [
  'relative h-12 rounded-none px-3 py-0 text-muted-foreground hover:text-foreground',
  'data-[state=active]:bg-transparent data-[state=active]:text-foreground data-[state=active]:shadow-none',
  "after:absolute after:inset-x-2 after:bottom-0 after:h-0.5 after:rounded-full after:content-['']",
  'data-[state=active]:after:bg-primary',
].join(' ');

export interface PageTabItem {
  value: string;
  label: ReactNode;
  testId: string;
}

export function PageTabs({
  value,
  onValueChange,
  items,
  label,
}: {
  value: string;
  onValueChange: (value: string) => void;
  items: PageTabItem[];
  label: string;
}) {
  return (
    <Tabs value={value} onValueChange={onValueChange}>
      <TabsList aria-label={label} className={PAGE_TABS_LIST_CLASS}>
        {items.map((item) => (
          <TabsTrigger key={item.value} value={item.value} data-testid={item.testId} className={PAGE_TABS_TRIGGER_CLASS}>
            {item.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
